<template>
  <div
    :id="vnodeId"
    ref="gridRootWrapper"
    class="position-relative visual-box"
    @mouseenter="mouseOverAction"
    @mouseleave="mouseLeaveAction"
  >
    <!--    box-color="#e9e9e98c"-->
    <visual-box
      ref="vsBox"
      :grid-column="column"
      box-color="#333333"
      :grid-column-height="cellHeight"
      :grid-v-node-id="vnodeId"
    />
    <div
      :key="'grid-stack-' + vnodeId + viewMode"
      ref="gridElement"
      :class="gridClassName"
      @mousedown.stop=""
      @mouseover.stop=""
    >
      <div
        v-if="
          fbNode.children.length === 0 &&
          parent().parent().name === 'CPopupBuilder'
        "
        class="d-flex justify-content-center"
      >
        <div class="popup-default-box">
          <!-- The enlarged Icon -->
          <span
            class="popup-default-icon cvt-icon-www-site-arrow-cursor"
          ></span>
          <!-- Select Popup Style text under the Icon -->
          <span class="popup-default-text">Select Popup Style</span>
          <!-- Button to open up Pre Made Popup Options on click -->
          <cvt-button
            class="popup-default-button"
            :icon="'arrow-right'"
            :prepend="false"
            :text="'Select Pre-Made Popup'"
            @click="click($event)"
          ></cvt-button>
        </div>
      </div>

      <div
        v-if="
          fbNode.children.length === 0 &&
          parent().parent().name !== 'CPopupBuilder'
        "
        class="empty-section-placeholder d-flex justify-content-center align-items-center"
      >
        <!-- Internal dashed box -->
      </div>

      <template v-for="node in fbNode.children">
        <grid-item-v3
          v-bind="node.data.props"
          :key="node.data.props.vnodeId"
          :fb-node="node"
          @removeElement="removeNode"
          @duplicateElement="duplicateNode"
          @forceRemoveElement="forceRemoveNode"
        ></grid-item-v3>
      </template>
    </div>
  </div>
</template>

<script>
import {get, set} from 'lodash'
import {AddCommand} from '../../../../commands/AddCommand'
import GridContainer from '../../../editor/nodes/GridContainer.vue'
import FirebaseNodeV3 from '../../base/FirebaseNode'
import GridBuilderMixin from '../../base/GridBuilderMixin'

export default GridContainer.extend({
  mixins: [FirebaseNodeV3, GridBuilderMixin],
  name: 'GridContainerV3',
  updated() {
    this.$nextTick(() => {
      this.$refs.vsBox.$forceUpdate()
    })
  },
  methods: {
    gridItemRemoved(e, items) {
      console.debug('Item Removed', e, items)
    },
    addGridItem(vNode, options) {
      if (['grid-box-container', 'sub-grid-container'].includes(vNode.tag)) {
        options.desktop.flexHorizonAlign = options.desktop.flexVerticalAlign =
          null
        options.phone.flexHorizonAlign = options.phone.flexVerticalAlign = null
      }
      if (['c-form'].includes(vNode.tag)) {
        this.setPageId(vNode)
        set(
          vNode,
          'data.props.fields',
          get(vNode, 'data.props.fields', []) || [],
        )
      }
      let widget = this.wrapInGridItemWrapper(vNode, options)
      this.pushCommand(new AddCommand(this, widget))
    },
    mouseOverAction(event) {
      this.$refs.vsBox.$el.classList.add('show-grid')
    },
    mouseLeaveAction(event) {
      this.$refs.vsBox.$el.classList.remove('show-grid')
    },
    getNewRow(viewMode){
      return this.fbNode.children.reduce((row, n) => Math.max(row, n.data.props[viewMode].dataY + n.data.props[viewMode].dataHeight), 0);
    },
    fixOptions(options, viewMode){
      const row = this.getNewRow(viewMode)
      let y = row === 0 ? 0: row
      return {...options, dataY: y}
    },
  },
})
</script>
